<template>
  <div  class="editor-top-row">

    <!-- Left side: label -->
    <span v-if="label" class="editor-label" v-html="label"></span>
    <!-- Right side: toolbar -->
    <div id="editorContainer">
      <div class="right editor-actions" style="margin-right: 0rem !important;">
        <span v-if="image" @click="modifyText('image')">
          <md-icon>image</md-icon>
        </span>
        <span @click="modifyText('link')">
          <md-icon>link</md-icon>
        </span>
        <span @click="modifyText('bullet')">
          <md-icon>format_list_bulleted</md-icon>
        </span>
        <span @click="modifyText('bold')">
          <md-icon>format_bold</md-icon>
        </span>
        <span @click="modifyText('underline')">
          <md-icon>format_underlined</md-icon>
        </span>
        <span @click="modifyText('undo')">
          <md-icon>undo</md-icon>
        </span>
      </div>
    </div>
    <LinkPromptModal
        v-if="options"
        :show="linkModal.show"
        :options="options"
        :initial="linkModal.initial"
        :variables="linkVariables"
        @confirm="applyLink($event)"
        @remove="removeLink"
        @cancel="linkModal.show = false" />
  </div>
</template>
<script>
import LinkPromptModal from '../modals/LinkPromptModal.vue';
import { parseLinkHref } from '../../utils/linkHref';
export default {
	name: 'TextEditorBox',
	components: { LinkPromptModal },
	props: {
		editor: Object,
		image: null,
    label: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: false,
      default: null
    },
    // placeholders the link modal offers per type; null = travel-expert defaults
    linkVariables: {
      type: Object,
      required: false,
      default: null
    }
	},
	data() {
		return {
			// link modal (website / e-mail / phone); initial = existing link to edit
			linkModal: { show: false, initial: null }
		};
	},
	methods: {
		modifyText(action) {
			const chain = this.editor.chain().focus();
			switch (action) {
				case 'bullet':
					chain.toggleBulletList().run();
					break;
				case 'bold':
					chain.toggleBold().run();
					break;
				case 'underline':
					chain.toggleUnderline().run();
					break;
				case 'undo':
					chain.undo().run();
					break;
				case 'link':
					this.setLink()
                	break;
				case 'image':
					this.promptUrl('Image-Url', '', (url) => {
						if (url) {
							this.editor.chain().focus().setImage({ src: url }).run();
						}
					});
			}
		},
		// Link button: opens the link modal; on an existing link it is pre-filled
		// (type detected from the href) and offers "remove".
		setLink() {
			if (!this.options) {
				// no app options = no modal host; keep the bare prompt as a fallback
				this.promptUrl('URL', this.editor.getAttributes('link').href || 'https://', (url) => {
					if (!url) return;
					this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
				});
				return;
			}
			const href = this.editor.isActive('link') ? (this.editor.getAttributes('link').href || '') : '';
			this.linkModal.initial = href ? parseLinkHref(href) : null;
			this.linkModal.show = true;
		},
		applyLink({ href }) {
			this.linkModal.show = false;
			this.editor.chain().focus().extendMarkRange('link').setLink({ href }).run();
		},
		removeLink() {
			this.linkModal.show = false;
			this.editor.chain().focus().extendMarkRange('link').unsetLink().run();
		},
		promptUrl(title, defaultValue, cb) {
			const gc = this.options && this.options.globalConfirm;
			if (!gc) {
				const url = window.prompt(title + ':', defaultValue);
				cb(url);
				return;
			}
			Object.assign(gc, {
				visible: true,
				styled: false,
				title,
				message: '',
				showInput: true,
				inputLabel: title,
				inputPlaceholder: 'https://...',
				inputValue: defaultValue || '',
				hideCancel: false,
				confirmBtnText: 'OK',
				confirmBtnClass: 'md-raised md-primary',
				onConfirm: () => {
					const val = gc.inputValue;
					gc.visible = false;
					gc.showInput = false;
					gc.inputValue = '';
					cb(val);
				},
				onCancel: () => {
					gc.visible = false;
					gc.showInput = false;
					gc.inputValue = '';
					cb(null);
				}
			});
		}
	},
};
</script>
<style scoped>
  #editorContainer div:first-child span:last-child {
    margin-right: 0 !important;
  }
	#editorContainer a {
    color: #68CEF8 !important;
    cursor: pointer !important;
    text-decoration: underline !important;
  }
  .editor-top-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .editor-label {
    font-weight: 600;
    font-size: 15px;
  }

  .editor-toolbar span {
    cursor: pointer;
    margin-left: 10px;
  }

  .editor-toolbar md-icon {
    font-size: 20px !important;
  }
.editor-actions{
  color: #68CEF8 !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}
</style>